// extracted by mini-css-extract-plugin
module.exports = {"root":"DefaultErrorBoundary_root__1cklX","heading":"DefaultErrorBoundary_heading__3YQnH","subHeading":"DefaultErrorBoundary_subHeading__1gpA1"};